import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { IoCartOutline } from "react-icons/io5";
import { FaStar } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../component/Loader";
import { useSettings } from "../context/settingContext";
import { toast } from "react-toastify";

function ProductDescription() {
    const { id } = useParams();
    const [getProd, setGetProd] = useState(null);
    const { renderHTML } = useSettings();
    const navigate = useNavigate();
    const [isAdding, setIsAdding] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [selectedOption, setSelectedOption] = useState(null);

    const getProdData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/get-product/${id}`
            );
            const productDetail = res.data.data.product_detail;
            setGetProd(productDetail);

            const existingCart = localStorage.getItem(productDetail.id);
            if (existingCart) {
                const parsed = JSON.parse(existingCart);
                if (parsed?.quantity) setQuantity(parsed.quantity);
            }
        } catch (err) {
            console.error("Fetching Product Detail Error:", err);
        }
    };

    const updateCart = (product, newQuantity) => {
        const existing = localStorage.getItem(product.id);
        const updatedItem = {
            ...product,
            quantity: typeof newQuantity === "number" ? newQuantity : 1,
        };

        if (existing) {
            const parsed = JSON.parse(existing);
            updatedItem.quantity =
                typeof newQuantity === "number" ? newQuantity : parsed.quantity + 1;
        }

        localStorage.setItem(product.id, JSON.stringify(updatedItem));
        window.dispatchEvent(new Event("cartUpdated"));
    };

    const updateQuantity = (productId, increment) => {
        let newQuantity = increment ? quantity + 1 : quantity - 1;
        if (newQuantity < 1) return;
        setQuantity(newQuantity);

        if (getProd) {
            updateCart(
                {
                    id: getProd.id,
                    name: getProd.name,
                    price: selectedOption ? selectedOption.price : getProd.discount_price,
                    photo: getProd.photo,
                    short_desc: getProd.sort_details,
                },
                newQuantity
            );
        }
    };

    const addCart = (e) => {
        e.preventDefault();
        if (getProd?.attributes?.length && !selectedOption) {
            toast.warning("Please select a size first!");
            return;
        }
        setIsAdding(true);
        updateCart(
            {
                id: getProd.id,
                name: getProd.name,
                price: selectedOption ? selectedOption.price : getProd.discount_price,
                photo: getProd.photo,
                short_desc: getProd.sort_details,
                volume: selectedOption ? selectedOption.name : null,
            },
            quantity
        );
        setTimeout(() => {
            setIsAdding(false);
            toast.success("Product added to cart successfully!");
            navigate("/cart");
        }, 800);
    };

    useEffect(() => {
        getProdData();
    }, [id]);

    if (getProd === null) return <Loader />;

    const displayPrice = selectedOption
        ? selectedOption.price
        : getProd.discount_price;

    return (
        <div className="bg-black min-h-screen">
            <section className="main-product-page pt-10 pb-10 mt-40">
                <div className="container mx-auto p-10">
                    <Row gutter={[16, 16]} justify="center" align="middle">
                        <Col span={12} style={{ textAlign: "center" }}>
                            <div className="main-product-slide p-[50px] bg-gray-900 mx-auto flex justify-center rounded-2xl shadow-lg">
                                <img
                                    className="mx-auto block"
                                    src={`${process.env.REACT_APP_SITE_IMAGES}${getProd.photo}`}
                                    alt={getProd.name}
                                />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="main-product-desciption text-white px-6">
                                <div className="product-dce-title">
                                    <h1 className="font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]">
                                        {getProd.name}
                                    </h1>
                                    <p className="text-gray-300 mb-6 font-outfit text-lg pt-2 border-b border-white pb-2">
                                        {getProd.sort_details}
                                    </p>
                                </div>
                                {renderHTML(getProd.details)}
                                <div className="pricing-section pt-5 pb-5">
                                    <div className="container mx-auto flex flex-col md:flex-row items-center gap-10">
                                        <div className="text-4xl font-bold text-white font-syne">
                                            ${displayPrice}
                                        </div>
                                        <div className="flex flex-col">
                                            <div className="flex items-center gap-3">
                                                <div className="flex text-yellow-400 text-2xl">
                                                    {[...Array(5)].map((_, i) => (
                                                        <FaStar key={i} />
                                                    ))}
                                                </div>
                                                <span className="text-lg font-medium">
                                                    5 Star Reviews
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-3 mt-3">
                                                <div className="flex -space-x-2">
                                                    {[1, 2, 3, 4].map((num) => (
                                                        <img
                                                            key={num}
                                                            src={`https://i.pravatar.cc/40?img=${num}`}
                                                            alt={`User ${num}`}
                                                            className="w-10 h-10 rounded-full border-2 border-black"
                                                        />
                                                    ))}
                                                </div>
                                                <span className="text-lg font-medium">
                                                    +10 Customer Reviews
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h2 className="font-syne text-3xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]">
                                    Volume Range
                                </h2>
                                {getProd?.attributes?.length > 0 &&
                                    getProd.attributes[0]?.options?.length > 0 && (
                                        <div className="flex justify-start items-center mt-3 mb-5 gap-3">
                                            {getProd.attributes[0].options.map((option) => (
                                                <label key={option.id} className="cursor-pointer">
                                                    <input
                                                        type="radio"
                                                        name={`size-${getProd.id}`}
                                                        className="peer hidden"
                                                        value={option.keyword}
                                                        onChange={() => setSelectedOption(option)}
                                                    />
                                                    <div className="px-6 py-2 font-outfit rounded-full border border-white text-white font-medium peer-checked:bg-gradient-to-r peer-checked:from-[#43AAD6] peer-checked:to-black">
                                                        {option.name}
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                {selectedOption && (
                                    <p className="text-sm text-white mt-2">
                                        Selected: {selectedOption.name} (${selectedOption.price})
                                    </p>
                                )}
                                <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-6">
                                    <li className="flex">
                                        <button
                                            onClick={addCart}
                                            className="font-syne flex items-center gap-5 bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] text-white px-6 py-3 rounded-full hover:bg-blue-700 transition"
                                        >
                                            <IoCartOutline />
                                            {isAdding ? "Adding..." : "Add to Cart"}
                                        </button>
                                    </li>
                                    <li className="flex justify-center items-center">
                                        <div className="flex items-center border border-white rounded-full px-6 py-2">
                                            <button
                                                disabled={quantity <= 1}
                                                onClick={() => updateQuantity(getProd.id, false)}
                                                className="text-white text-xl px-2"
                                            >
                                                -
                                            </button>
                                            <span className="text-white text-lg px-4 font-syne">
                                                {quantity}
                                            </span>
                                            <button
                                                onClick={() => updateQuantity(getProd.id, true)}
                                                className="text-white text-xl px-2"
                                            >
                                                +
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    );
}

export default ProductDescription;
